/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import GalleryImageEditor from 'DesignSystem/GalleryImageEditor/react'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Images/ActiveTab/Images/Content/Content/Content/ImageViewer/Content/PatientImages/Preview/Content"
  
}) {
let resourcePreviewUrlValueData = fromData.useDataValue({ viewPath,
context: 'resource',
path: 'preview_url',
})
let galleryIsToolbarHiddenValueData = fromData.useDataValue({ viewPath,
context: 'gallery',
path: 'is_toolbar_hidden',
})
  return (<React.Fragment
>
<GalleryImageEditor
  viewPath={`${viewPath}/GalleryImageEditor`}
 data="resource.preview_url"
 src={resourcePreviewUrlValueData}
 data="gallery.is_toolbar_hidden"
 isToolbarHidden={galleryIsToolbarHiddenValueData}
/>
{children}
</React.Fragment>)
}